import { render, staticRenderFns } from "./CreateRequestSlidebar.vue?vue&type=template&id=67bb7abf"
import script from "./CreateRequestSlidebar.vue?vue&type=script&lang=js"
export * from "./CreateRequestSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports